import React from 'react';
import { Datagrid, TextField, Filter, TextInput, usePermissions } from 'react-admin';

import { List } from '~/layout';
import { NoPermissions, ProfileTagsFilter, StatusField, TranslateField } from '~/components/ra';
import PartnerCreate from './PartnerCreate';
import { makeStyles } from '@material-ui/core/styles';

// Add l function for translation
const l = (key: string): string => `resources.partners.fields.${key}`;

const PartnersList = (props: any) => {
  const { permissions } = usePermissions();
  const classes = useStyles();

  if (!permissions) return null;
  if (!permissions?.includes('partner.list')) return <NoPermissions />;
  return (
    <List
      bulkActionButtons={false}
      {...props}
      sort={{ field: 'name', order: 'ASC' }}
      actions={<PartnerCreate permissions={permissions} />}
      filters={
        <Filter className={classes.form}>
          <TextInput label={l('name')} source='name' alwaysOn className={classes.formControl} />
          <TextInput
            label={l('externalId')}
            source='externalId'
            alwaysOn
            className={classes.formControl}
          />
          <TextInput
            label={l('accountNumber')}
            source='accountNumber'
            alwaysOn
            className={classes.formControl}
          />
          <ProfileTagsFilter resource='partners' className={classes.formControlLong} alwaysOn />
        </Filter>
      }
    >
      <Datagrid rowClick='show' size='medium' selectedIds={null}>
        <TextField source='name' label={l('name')} />
        <TextField source='description' label={l('description')} />
        <TranslateField
          i18nPath='resources.partners.fields'
          source='transfersDirection'
          label={l('transfersDirection')}
          sortable={false}
        />
        <TextField source='externalId' label={l('externalId')} />
        <TextField source='accountNumber' label={l('accountNumber')} />
        <TextField source='accountAlias' label={l('accountAlias')} />
        <StatusField source='status' label={l('status')} />
      </Datagrid>
    </List>
  );
};

const useStyles = makeStyles((theme) => ({
  form: {
    alignItems: 'flex-start',
    '& > div': {
      '& > div:last-child': {
        width: theme.spacing(1),
      },
    },
  },
  formControl: { width: 210 },
  formControlLong: {
    width: 210 * 2 + theme.spacing(1),
  },
}));

export default PartnersList;
